import noop from 'lodash/noop'
import { showCreatePasswordModal } from '@/features/Auth/CreatePasswordModal'
import { handle } from './promise'

const handleSession = async <T>(
  promise: Promise<T>,
  afterSetPassword = noop
): Promise<[T | undefined, unknown]> => {
  const [result, error] = await handle(promise)
  if (error?.data?.password_setup_required && typeof window !== 'undefined') {
    showCreatePasswordModal({ afterSetPassword })
  }
  return [result, error]
}

export default handleSession
